// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Print-specific styles for receipts */

@media print {
  /* Hide everything by default */
  body * {
    visibility: hidden;
  }

  /* Show only receipt and its children */
  .receipt,
  .receipt * {
    visibility: visible;
  }

  /* Position receipt at top */
  .receipt {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    max-width: 80mm;
    margin: 0;
    padding: 10mm;
  }

  /* Hide UI elements during print */
  .no-print,
  .no-print * {
    display: none !important;
    visibility: hidden !important;
  }

  /* Remove backgrounds and shadows */
  body {
    background: white !important;
  }

  /* Optimize for thermal printers */
  @page {
    size: 80mm auto;
    margin: 0;
  }

  /* Ensure black and white */
  * {
    color: black !important;
    background: white !important;
  }

  /* Keep borders visible */
  .receipt .border-t,
  .receipt .border-b,
  .receipt [class*="border"] {
    border-color: black !important;
  }

  /* Avoid page breaks inside sections */
  .receipt-section {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  /* Ensure proper spacing */
  .receipt-header,
  .receipt-footer {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}

/* Screen styles for print preview */
.print-preview {
  max-width: 80mm;
  margin: 0 auto;
  background: white;
  padding: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

/* Print button (hidden during actual print) */
.print-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

@media print {
  .print-button {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/print.css"],"names":[],"mappings":"AAAA,uCAAuC;;AAEvC;EACE,+BAA+B;EAC/B;IACE,kBAAkB;EACpB;;EAEA,uCAAuC;EACvC;;IAEE,mBAAmB;EACrB;;EAEA,4BAA4B;EAC5B;IACE,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;IACX,eAAe;IACf,SAAS;IACT,aAAa;EACf;;EAEA,kCAAkC;EAClC;;IAEE,wBAAwB;IACxB,6BAA6B;EAC/B;;EAEA,mCAAmC;EACnC;IACE,4BAA4B;EAC9B;;EAEA,kCAAkC;EAClC;IACE,eAAe;IACf,SAAS;EACX;;EAEA,2BAA2B;EAC3B;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;;EAEA,yBAAyB;EACzB;;;IAGE,8BAA8B;EAChC;;EAEA,sCAAsC;EACtC;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA,0BAA0B;EAC1B;;IAEE,wBAAwB;IACxB,mBAAmB;EACrB;AACF;;AAEA,oCAAoC;AACpC;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,wCAAwC;AAC1C;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Print-specific styles for receipts */\n\n@media print {\n  /* Hide everything by default */\n  body * {\n    visibility: hidden;\n  }\n\n  /* Show only receipt and its children */\n  .receipt,\n  .receipt * {\n    visibility: visible;\n  }\n\n  /* Position receipt at top */\n  .receipt {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    max-width: 80mm;\n    margin: 0;\n    padding: 10mm;\n  }\n\n  /* Hide UI elements during print */\n  .no-print,\n  .no-print * {\n    display: none !important;\n    visibility: hidden !important;\n  }\n\n  /* Remove backgrounds and shadows */\n  body {\n    background: white !important;\n  }\n\n  /* Optimize for thermal printers */\n  @page {\n    size: 80mm auto;\n    margin: 0;\n  }\n\n  /* Ensure black and white */\n  * {\n    color: black !important;\n    background: white !important;\n  }\n\n  /* Keep borders visible */\n  .receipt .border-t,\n  .receipt .border-b,\n  .receipt [class*=\"border\"] {\n    border-color: black !important;\n  }\n\n  /* Avoid page breaks inside sections */\n  .receipt-section {\n    page-break-inside: avoid;\n    break-inside: avoid;\n  }\n\n  /* Ensure proper spacing */\n  .receipt-header,\n  .receipt-footer {\n    page-break-inside: avoid;\n    break-inside: avoid;\n  }\n}\n\n/* Screen styles for print preview */\n.print-preview {\n  max-width: 80mm;\n  margin: 0 auto;\n  background: white;\n  padding: 20px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n/* Print button (hidden during actual print) */\n.print-button {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 1000;\n}\n\n@media print {\n  .print-button {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
